import React from 'react';
import Svg, { Path, Circle } from 'react-native-svg';
import { Props } from '../../../shared/assets/SvgProps';

const WorkOrderAssignedIcon: React.FC<Props> = () => (
  <Svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <Circle cx="12" cy="12" r="10" stroke="#E7000B" strokeWidth="1.66667" />
    <Path
      d="M12 16V12"
      stroke="#E7000B"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M12 8h.01"
      stroke="#E7000B"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default WorkOrderAssignedIcon;
